import { Component, Input, ViewChild } from '@angular/core';
import { ContactCardComponent } from '@hub/components/v1/_common/contact-cards/contact-card.component';

@Component({
  selector: 'label-contact-card',
  templateUrl: 'label-contact-card.component.html'
})
export class LabelContactCardComponent {
  @ViewChild(ContactCardComponent) contactCard: ContactCardComponent;
  @Input() set card(card: any) {
    this._card = card;
    this.isCardEmpty = !card;
  }
  get card() {
    return this._card;
  }
  @Input() text: string;
  @Input() iconType: string;
  @Input() emptyCardText: string = '';
  isCardEmpty = false;

  private _card: any;

  showToggle(event) {
    this.contactCard.showContactCard(event, event.currentTarget);
  }

  hideContactCard() {
    this.contactCard.hideContactCard();
  }
}
